module.exports = __webpack_public_path__ + "static/media/cedula-20.1b41dc2f.png";